module.exports = __webpack_public_path__ + "static/media/Avaya.d14514d6.jpg";